__turbopack_context__.v({
  "horizontalRule": "-kYtoW_horizontalRule",
});
